<template>
  <BaseModalDialog v-if="actionSavedVisible">
    <h2>Action Saved</h2>
    <a v-on:click="hideActionSavedConfirmation" href="#" class="btn btn-primary"
      >OK</a
    >
  </BaseModalDialog>
  <!-- HTML template -->
  <div class="messages">
    <!-- this is the message list sidebar -->
    <section class="messages--overview">
      <header class="messages--header">
        <h2 class="messages--title">Messages</h2>
        <div class="buttongroup messages--tabs">
          <a
            href="#"
            class="btn"
            v-bind:class="{ 'btn-active': activeTab === 'notes' }"
            v-on:click="activeTab = 'notes'"
            >Session Notes Alerts
            <small
              v-if="globalUrgentNoteCount > 0"
              class="btn--count alert"
              aria-label="Note count"
              >{{ $root.formatNumber(globalUrgentNoteCount) }}</small
            ></a
          >
          <a
            href="#"
            class="btn"
            v-bind:class="{ 'btn-active': activeTab === 'chat' }"
            v-on:click="activeTab = 'chat'"
            >Other Messages
            <small
              v-if="globalUnreadMessages > 0"
              class="btn--count"
              aria-label="Unread message count"
              >{{ $root.formatNumber(globalUnreadMessages) }}</small
            ></a
          >
        </div>
        <div
          v-if="activeTab === 'notes'"
          class="messages--filter-sort-container"
        >
          <div>
            <div
              class="btn"
              v-on:click="sortCurrentNotesList()"
              v-if="showDoneNotes == 'show'"
            >
              Sort
              {{
                this.noteListSort == "asc"
                  ? "↑"
                  : this.noteListSort == "desc"
                    ? "↓"
                    : ""
              }}
            </div>
          </div>
          <div class="field field-checkbox">
            <input
              type="checkbox"
              id="show_done"
              v-model="showDoneNotes"
              true-value="show"
              false-value="hide"
              class="field--checkbox"
            />
            <label
              for="show_done"
              class="field--label field--label-checkbox messages--centerline"
              >Show done messages</label
            >
          </div>
        </div>
        <div v-else class="field field-checkbox">
          <input
            type="checkbox"
            id="show_read"
            name="show_read"
            v-model="showReadMessages"
            true-value="show"
            false-value="hide"
            class="field--checkbox"
          />
          <label for="show_read" class="field--label field--label-checkbox"
            >Show read messages</label
          >
        </div>
      </header>
      <!-- other messages section -->
      <div class="msg_list_container">
        <!-- Session notes -->
        <ul
          class="msg_list_container--content msg_list"
          v-if="activeTab === 'notes'"
        >
          <!-- begin selected/active list item -->
          <li
            v-for="note in currentNotesList"
            v-bind:key="note.id"
            class="msg_list--item"
            v-bind:class="{ 'msg_list--item-unread': note.status === 'open' }"
            v-on:click="
              showUrgentAlert(
                note.peer,
                note.id,
                `${note.mentor_first_name} ${note.mentor_last_name}`,
                `${note.mentee_first_name} ${note.mentee_last_name}`
              )
            "
          >
            <a class="msg_list--link msg_list--link-mentor" href="#"
              ><span class="msg_list--text"
                >{{ note.mentor_first_name }} {{ note.mentor_last_name }}</span
              ></a
            >
            <div class="msg_list--peer">
              Peer:
              <span class="msg_list--peer_name"
                >{{ note.mentee_first_name }} {{ note.mentee_last_name }}</span
              >
            </div>
          </li>
          <!-- end selected/active list item -->
        </ul>

        <!-- Chat messages -->
        <ul
          class="msg_list_container--content msg_list"
          v-if="activeTab === 'chat'"
        >
          <!-- begin selected/active list item -->
          <li
            v-for="user in currentUsersList"
            v-bind:key="user.id"
            v-on:click="showChat(user)"
            v-bind:class="{
              'msg_list--item-unread': user.unread_messages_count > 0,
            }"
            class="msg_list--item"
          >
            <a class="msg_list--link" href="#">
              <span class="msg_list--text"
                >{{ user.last_name }}, {{ user.first_name }}</span
              >
              <!-- <small class="msg_list--status">(Mentor)</small> -->
              <small
                v-if="user.unread_messages_count > 0"
                class="alert"
                aria-label="Message count"
                >{{ $root.formatNumber(user.unread_messages_count) }}</small
              >
            </a>
          </li>
          <!-- end selected/active list item -->
        </ul>
      </div>
      <!-- end other messages section -->
    </section>
    <!-- end sidebar -->
    <div class="messages--content">
      <AdminUrgentMessage
        ref="UrgentMessage"
        v-on:close="hideUrgentAlert"
        v-on:closedUrgentAlert="removeUrgentAlert"
        v-on:actionSaved="showActionSavedConfirmation"
      />
      <AdminChat
        ref="chat"
        v-on:readMessages="processReadMessages"
        v-on:unreadMessages="processUnreadMessages"
      
      />
    </div>
    <!-- end content area -->
  </div>
</template>
<script>
import BodyClass from "../mixins/BodyClass";
import PageTitle from "../mixins/PageTitle";
import AdminUrgentMessage from "../components/AdminUrgentMessage.vue";
import AdminChat from "../components/AdminChat.vue";
import BaseModalDialog from "../components/BaseModalDialog";
export default {
  name: "AdminMessaging",

  components: {
    AdminUrgentMessage,
    AdminChat,
    BaseModalDialog,
  },

  mixins: [BodyClass, PageTitle],

  data() {
    return {
      bodyClass: "admin",
      allUrgentNotes: [],
      mentors: new Map(), // names of all mentors
      mentees: new Map(), // names of all mentees
      users: [],
      myId: null, // userId of the current user
      messagingUser: null, //user object for the user to chat with
      actionSavedVisible: false,
      activeTab: "notes",
      showDoneNotes: "hide",
      showReadMessages: "hide",
      noteListSort: "",
      intervalId: null,
    };
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  computed: {
    openUrgentNotes() {
      return this.allUrgentNotes.filter((note) => note.status === "open");
    },
    currentNotesList() {
      if (this.showDoneNotes === "hide") {
        return this.openUrgentNotes;
      }
      return this.allUrgentNotes;
    },
    globalUnreadMessages() {
      return this.$root.unreadMessageCount;
    },
    globalUrgentNoteCount() {
      return this.$root.urgentNoteCount;
    },
    usersWithUnreadMessages() {
      return this.users.filter((user) => user.unread_messages_count > 0);
    },
    currentUsersList() {
      if (this.usersWithUnreadMessages.length == 0) {
        return this.users;
      }
      if (this.showReadMessages === "hide") {
        
        return this.usersWithUnreadMessages;
      }
      return this.users;
    },
  },

  watch: {
    // When global unread message count changes. trigger a refresh of the unread message count
    globalUnreadMessages() {
      console.log("WATCH MESSAGES");
      this.getUsersForMessaging();
    },
    globalUrgentNoteCount() {
      console.log("WATCH NOTES");
      this.getAllUrgentNotes();
    },
  },

  created() {
    this.getAllUrgentNotes();
    this.getUsersForMessaging();
  },

  mounted() {
    // Turn off the urgentMessage modal once the user views this page
    this.$root.urgentMessageCount = 0;
    this.intervalId = setInterval(() => {
      this.getUsersForMessaging();
    }, 5000);
  },

  methods: {
    sortCurrentNotesList() {
      console.log(this.currentNotesList);
      switch (this.noteListSort) {
        case "desc":
          this.noteListSort = "asc";
          this.currentNotesList.sort(function (b, a) {
            return new Date(b.date_created) - new Date(a.date_created);
          });
          break;
        case "asc":
          this.noteListSort = "desc";
          this.currentNotesList.sort(function (a, b) {
            return new Date(b.date_created) - new Date(a.date_created);
          });
          break;
        default:
          this.noteListSort = "asc";
          this.currentNotesList.sort(function (b, a) {
            return new Date(b.date_created) - new Date(a.date_created);
          });
          break;
      }
      console.log(this.noteListSort);
    },
    getAllUrgentNotes() {
      // Get open urgent alerts
      this.$root.callAuthenticatedEndpointNEW("getAllUrgentNotes", (resp) => {
        this.allUrgentNotes = resp.results;
      });
    },

    getUsersForMessaging() {
      // For chat section - get all mentor and mentee IDs and unread message counts
      this.$root.callAuthenticatedEndpointNEW(
        "getUsersAdminMessaging",
        (users) => {
          this.users = users;
        }
      );
    },

    hideActionSavedConfirmation() {
      this.actionSavedVisible = false;
    },

    showActionSavedConfirmation() {
      this.actionSavedVisible = true;
    },

    showUrgentAlert(menteeId, sessionNoteId, mentorName, menteeName) {
      this.$refs.UrgentMessage.show(
        menteeId,
        sessionNoteId,
        mentorName,
        menteeName
      );
      this.$refs.chat.hide();
    },
    hideUrgentAlert() {
      this.activeUrgentAlert = "";
      this.$refs.UrgentMessage.hide();
    },
    showChat(user) {
      this.$refs.chat.show(user);
      this.$refs.UrgentMessage.hide();
    },
    hideChat() {
      this.$refs.chat.hide();
    },
    getMentorName(id) {
      const mentor = this.mentors.get(id);
      if (mentor === undefined) {
        return "";
      } else {
        return mentor["first_name"] + " " + mentor["last_name"];
      }
    },
    getMenteeName(id) {
      const mentee = this.mentees.get(id);
      if (mentee === undefined) {
        return "";
      } else {
        return mentee["first_name"] + " " + mentee["last_name"];
      }
    },

    // An alert can be in either list, or both
    removeUrgentAlert(sessionNoteId) {
      // Updating the $root count is handled in the AdminUrgentMessage component
      const noteIndex = this.allUrgentNotes.findIndex(
        (note) => note.id === sessionNoteId
      );
      if (noteIndex > -1) {
        this.allUrgentNotes[noteIndex].status = "close";
      }
    },

    // Reduce unread message count when chat messages are read
    processReadMessages(userId, count) {
      console.log("PROCESS EMIT");
      const userIndex = this.users.findIndex((user) => user.id === userId);
      console.log("userIndex " + userIndex);
      // reset component-level total unread messages (used at top of left column)
      this.unreadMessageCount -= count;
      // reset unread message count in user list (used for bubbles next to user name in chat list)
      this.users[userIndex].unread_messages_count -= count;
      if (this.users[userIndex].unread_messages_count < 0) {
        this.users[userIndex].unread_messages_count = 0;
      }
      // Reset app-level unread message count (used in navbar)
      this.$root.decrementUnreadMessageCount(count);
    },

    processUnreadMessages(userId, count) {
      console.log("PROCESS EMIT");
      const userIndex = this.users.findIndex((user) => user.id === userId);
      console.log("userIndex " + userIndex);
      // reset component-level total unread messages (used at top of left column)
      this.unreadMessageCount += count;
      // reset unread message count in user list (used for bubbles next to user name in chat list)
      this.users[userIndex].unread_messages_count += count;
      // Reset app-level unread message count (used in navbar)
      this.$root.incrementUnreadMessageCount(count);
    },
  },
};
</script>
